import { userDomain } from '@/services';

export default {
	namespaced: true,
	state: {
		userDomain: {},
		needChange: false,
	},
	mutations: {
		SET_USERDOMAIN(state, { userDomain = {}, needChange = false }) {
			state.userDomain = userDomain;
			state.needChange = needChange;
		},
	},
	actions: {
		async initUserDomain({ commit }) {
			const { data, ok } = await userDomain.getDomainStatus();
			if (!ok) return;
			commit('SET_USERDOMAIN', data.data);
		},
	},
};
